<!--*ngIf="(contact_visible['WorkDays'] && contact.workdays) || !_isLoading"-->
<div class="flex sm:items-center">
    <table cellpadding="1" cellspacing="1">
        <tr>
            <td style="text-align:center;line-height: 1px !important;vertical-align: bottom;padding: 0;margin: 0;">
                <mat-icon *ngIf="(today == 0)" class="icon-size-6" [svgIcon]="'mat_outline:arrow_drop_down'" [style.color]="arrowIconColor" style="position: relative; bottom: -3px;"></mat-icon>
            </td>
            <td style="text-align:center;line-height: 1px !important;vertical-align: bottom;padding: 0;margin: 0;">
                <mat-icon *ngIf="(today == 1)" class="icon-size-6" [svgIcon]="'mat_outline:arrow_drop_down'" [style.color]="arrowIconColor" style="position: relative; bottom: -3px;"></mat-icon>
            </td>
            <td style="text-align:center;line-height: 1px !important;vertical-align: bottom;padding: 0;margin: 0;">
                <mat-icon *ngIf="(today == 2)" class="icon-size-6" [svgIcon]="'mat_outline:arrow_drop_down'" [style.color]="arrowIconColor" style="position: relative; bottom: -3px;"></mat-icon>
            </td>
            <td style="text-align:center;line-height: 1px !important;vertical-align: bottom;padding: 0;margin: 0;">
                <mat-icon *ngIf="(today == 3)" class="icon-size-6" [svgIcon]="'mat_outline:arrow_drop_down'" [style.color]="arrowIconColor" style="position: relative; bottom: -3px;"></mat-icon>
            </td>
            <td style="text-align:center;line-height: 1px !important;vertical-align: bottom;padding: 0;margin: 0;">
                <mat-icon *ngIf="(today == 4)" class="icon-size-6" [svgIcon]="'mat_outline:arrow_drop_down'" [style.color]="arrowIconColor" style="position: relative; bottom: -3px;"></mat-icon>
            </td>
            <td style="text-align:center;line-height: 1px !important;vertical-align: bottom;padding: 0;margin: 0;">
                <mat-icon *ngIf="(today == 5)" class="icon-size-6" [svgIcon]="'mat_outline:arrow_drop_down'" [style.color]="arrowIconColor" style="position: relative; bottom: -3px;"></mat-icon>
            </td>
            <td style="text-align:center;line-height: 1px !important;vertical-align: bottom;padding: 0;margin: 0;">
                <mat-icon *ngIf="(today == 6)" class="icon-size-6" [svgIcon]="'mat_outline:arrow_drop_down'" [style.color]="arrowIconColor" style="position: relative; bottom: -3px;"></mat-icon>
            </td>
        </tr>
        <tr>
            <td class="schedule-day-of-week pb-2" [class]="labelTextColorClass" [ngClass]="{'pl-2': showLeftBorder}">
                S
            </td>
            <td class="schedule-day-of-week pb-2" [ngClass]="labelTextColorClass">
                M
            </td>
            <td class="schedule-day-of-week pb-2" [ngClass]="labelTextColorClass">
                T
            </td>
            <td class="schedule-day-of-week pb-2" [ngClass]="labelTextColorClass">
                W
            </td>
            <td class="schedule-day-of-week pb-2" [ngClass]="labelTextColorClass">
                T
            </td>
            <td class="schedule-day-of-week pb-2" [ngClass]="labelTextColorClass">
                F
            </td>
            <td class="schedule-day-of-week pb-2" [ngClass]="labelTextColorClass">
                S
            </td>
        </tr>
        <tr [ngClass]="{'border-l-2 border-[#000f70] pl-2': showLeftBorder}">
            <td *ngFor="let dayKey of weekDayKeys; let i = index" class="schedule-day-cell this" [ngClass]="{'pl-2': i === 0}">
                <button matButton="outlined"
                  class="text-sm font-semibold rounded-md border-2 px-[10px] py-[4px]"
                  [ngClass]="getButtonClasses(dayKey, 'this', i)"
                  (click)="selectWorkDay('this', dayKey, i)">
                  <span>
                    {{ formatScheduleDay(getThisWeekDay(dayKey)) }}
                  </span>
                </button>
            </td>
        </tr>
        <tr>
            <td class="select-none" colspan="7" style="text-align: center; line-height: 34px;">
                <span class="uppercase" [ngClass]="labelTextColorClass" style="font-size: 12px; letter-spacing: 1px;">This Week</span>
            </td>
        </tr>
        <tr><td colspan="7" style="line-height:8px">&nbsp;</td></tr>
        <tr [ngClass]="{'border-l-2 border-[#000f70] pl-2': showLeftBorder}">
            <td *ngFor="let dayKey of weekDayKeys; let i = index" class="schedule-day-cell next" [ngClass]="{'pl-2': i === 0}">
                <button matButton="outlined"
                  class="text-sm font-semibold rounded-md border-2 px-[10px] py-[4px]"
                  [ngClass]="getButtonClasses(dayKey, 'next', i)"
                  (click)="selectWorkDay('next', dayKey, i)">
                  <span>
                    {{ formatScheduleDay(getNextWeekDay(dayKey)) }}
                  </span>
                </button>
            </td>
        </tr>
        <tr>
            <td class="select-none" colspan="7" style="text-align: center; line-height: 34px;">
                <span class="uppercase" [ngClass]="labelTextColorClass" style="font-size: 12px; letter-spacing: 1px;">Next Week</span>
            </td>
        </tr>
    </table>
</div>
